const SET_REF_TIME = 'TIMEOUT/SET_REF_TIME'
// TODO: add more action types if necessary

export {
  // eslint-disable-next-line import/prefer-default-export
  SET_REF_TIME,
  // TODO: export action types added later
}
